import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { Box, Divider, Typography, Checkbox, Button } from '@mui/material';

import WhatsappMailCompose from 'src/sections/@dashboard/leadDetail/mail/whatsappMailCompose';
import Iconify from '../Iconify';
import { useSelector } from '../../redux/store';
import {
    sendEmailBoxStyle,
    sendEmailTitleStyle,
    statusBadgeDoneStyle,
    statusBadgeOptionalStyle,
    successBannerWaStyle,
    successBannerCheckWaStyle,
    successBannerTextStyle,
} from '../../styles/FailedToAttendTabs';

const SendWhatsappContent = ({ handleAccordian, whatsappChecked, whatsappNotification, whatsapp, whatsappMessageSuccess, flowUpdateFunc, setWhatsappNotification, chevronIcon }) => {
    const { whatsappAccountData } = useSelector((state) => state.whatsappAccount);
    const navigate = useNavigate();

    const goToWhatsappPage = () => {
        flowUpdateFunc();
        navigate('/dashboard/whatsapp');
    };

    return (
        <>
            <Box>
                <Box onClick={() => handleAccordian('whatsapp')} sx={sendEmailBoxStyle}>
                    <Typography sx={sendEmailTitleStyle}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Box sx={{ fontSize: '18px', fontWeight: 700, ml: '-8px' }}>
                                <Checkbox checked={whatsappChecked} icon={<Iconify icon={'material-symbols:circle-outline'} width={24} height={24} />} checkedIcon={<Iconify icon={'bi:check-circle-fill'} width={24} height={24} />} /> Send a WhatsApp
                            </Box>
                            {whatsappChecked
                                ? <Box sx={statusBadgeDoneStyle}>Done</Box>
                                : <Box sx={statusBadgeOptionalStyle}>Optional</Box>
                            }
                        </Box>
                        {chevronIcon ? chevronIcon(whatsapp) : <Iconify width={20} height={20} icon={'eva:chevron-down-fill'} sx={{ color: '#919EAB' }} />}
                    </Typography>
                </Box>
                {whatsappNotification &&
                    <Box sx={successBannerWaStyle}>
                        <Box sx={successBannerCheckWaStyle}><Iconify icon={'eva:checkmark-fill'} width={12} height={12} color='#fff' /></Box>
                        <Typography sx={successBannerTextStyle}>WhatsApp message sent successfully!</Typography>
                    </Box>
                }
                {whatsapp ?
                    <Box>
                        {whatsappAccountData?.results?.length === 0 ?
                            <Button variant='contained' sx={{ my: 2, textTransform: 'none !important' }} onClick={() => goToWhatsappPage()}>
                                Connect to whatsApp
                            </Button>
                            : <WhatsappMailCompose
                                whatsappMessageSuccess={whatsappMessageSuccess}
                                setWhatsappNotification={setWhatsappNotification}
                            />}
                    </Box>
                    : null}
            </Box>
            <Divider sx={{ m: '16px 0' }} />
        </>
    );
};

SendWhatsappContent.propTypes = {
    handleAccordian: PropTypes.func,
    whatsappChecked: PropTypes.bool,
    whatsappNotification: PropTypes.bool,
    whatsapp: PropTypes.bool,
    whatsappMessageSuccess: PropTypes.func,
    flowUpdateFunc: PropTypes.func,
    setWhatsappNotification: PropTypes.func,
    chevronIcon: PropTypes.func,
};

export default SendWhatsappContent;
